module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Master3-1249ec733ad6a6d394ac36cc0a52d202.jpg";